import { zodResolver } from "@hookform/resolvers/zod"
import { SearchIcon } from "lucide-react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { ComboBox } from "@/components/ui/combo-box"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useAccessManagementSearchParams } from "@/hooks"
import type { FilterAccessManagementFormSchemaProps } from "@/schemas/filter-access-management"
import { filterAccessManagementFormSchema } from "@/schemas/filter-access-management"
const groupOptions = [
  {
    label: "Todos",
    value: "",
  },
  {
    label: "Administrador",
    value: "admin",
  },
  {
    label: "Visualizar dashboard",
    value: "dashboard",
  },
  {
    label: "Visualizar agenda",
    value: "schedule",
  },
  {
    label: "Visualizar vendas",
    value: "sales",
  },
  {
    label: "Alterar pedidos",
    value: "order-writing",
  },
  {
    label: "Visualizar pedidos",
    value: "order-reading",
  },
  {
    label: "Alterar assinaturas",
    value: "subscriptions-writing",
  },
  {
    label: "Visualizar assinaturas",
    value: "subscriptions-reading",
  },
]
export const AccessManagementFilterForm = () => {
  const navigate = useNavigate()
  const { params } = useAccessManagementSearchParams()
  const form =
    useForm<FilterAccessManagementFormSchemaProps>({
      resolver: zodResolver(
        filterAccessManagementFormSchema
      ),
      defaultValues: {
        name: params?.name,
        email: params?.email,
        groups: params?.groups,
      },
    })
  const handleSubmit = form.handleSubmit((data) => {
    const params = new URLSearchParams()
    Object.entries(data).forEach(([key, value]) => {
      if (key === "groups" && value === "") {
        return params.delete(key)
      }
      if (value) {
        params.set(key, value)
      } else {
        params.delete(key)
      }
    })
    navigate(`?${params.toString()}`)
  })
  return (
    <div className="@container">
      <Form {...form}>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col items-center gap-4 @2xl:flex-row"
        >
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormControl>
                  <Input
                    placeholder="Buscar por Nome"
                    {...field}
                    className="w-full"
                    type="search"
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormControl>
                  <Input
                    placeholder="Buscar por E-mail"
                    {...field}
                    className="w-full"
                    type="search"
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="groups"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormControl>
                  <ComboBox
                    items={groupOptions}
                    placeholder="Buscar por Grupo"
                    selected={field.value}
                    onSelect={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <div className="flex w-full justify-end @2xl:w-auto">
            <Button
              type="submit"
              className="btn-whitelabel w-full @2xl:w-auto"
            >
              <SearchIcon size={18} className="mr-2" />
              Buscar
            </Button>
          </div>
        </form>
      </Form>
    </div>
  )
}
